<template>
  <div id="app">
    <router-view />
    <!-- <base-socket /> -->
  </div>
</template>

<script>
// import BaseSocket from '@/components/BaseSocket';

export default {
  name: 'App',
  components: {
    // BaseSocket,
  },
};
</script>

<style>
  #app {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }
</style>
